// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.101.2_esbuild@0.25.9_postcss@8.5.6_/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.thumbnail-img {
  cursor: pointer;
  border: 1px solid transparent;
  border-radius: 5px;
  transition: border-color 0.5s ease;
  width: 25%;
}

.thumbnail-img.active {
  border-color: #0099e5;
}

.main-img {
  max-width: 100%;
  border-radius: 10px;
}

.color-swatch {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 3px solid transparent;
  cursor: pointer;
}

.color-swatch.active {
  border-color: #0099e5;
}

.feature-box {
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 12px;
  padding: 8px 12px;
  min-width: 180px;
  position: relative;
  transition: border-color 0.3s ease;
  cursor: pointer;
}

.feature-box:hover {
  border-color: #0099e5;
}

.feature-box img {
  border-radius: 4px;
}

.badge {
  font-size: 10px;
  margin-top: -8px;
}

.card-img-top {
  max-height: 300px;
  object-fit: contain;
}

.card {
  transition: transform 0.3s ease-in-out;
}

.card:hover {
  transform: scale(1.015);
  border-bottom: 3px solid #0099e5 !important;
}

.tab-pane ul li {
  padding: 0.5rem 0;
}

.tab-pane strong {
  color: #333;
}

.tab-pane .text-muted {
  font-size: 0.95rem;
}

.rating-input i {
  color: #ccc;
  font-size: 1.25rem;
  cursor: pointer;
  transition: color 0.2s ease;
}

.rating-input i:hover,
.rating-input i.active,
.rating-input i.hovered {
  color: #0099e5;
}

.btn-custom-theme {
  background-color: #0099e5;
  border: none;
  color: #fff;
  transition: background-color 0.3s ease;
}

.btn-custom-theme:hover,
.btn-custom-theme:focus {
  background-color: #0078c2; /* Slightly darker shade on hover */
  color: #fff;
}

.rate {
  float: left;
  height: 46px;
  padding: 0x;
}

.rate:not(:checked) > input {
  position: absolute;
  left: -9999px;
  pointer-events: none;
}

.rate:not(:checked) > label {
  float: right;
  width: 1em;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  font-size: 30px;
  color: #ccc;
}

.rate:not(:checked) > label:before {
  content: "★ ";
}

.rate > input:checked ~ label {
  color: var(--primary);
}

.rate:not(:checked) > label:hover,
.rate:not(:checked) > label:hover ~ label {
  color: var(--primary);
}

.rate > input:checked + label:hover,
.rate > input:checked + label:hover ~ label,
.rate > input:checked ~ label:hover,
.rate > input:checked ~ label:hover ~ label,
.rate > label:hover ~ input:checked ~ label {
  color: var(--primary);
}

.isActive {
  background-color: #e15454 !important;
  color: white;
}

.btn-animation.btn-disabled,
.btn-animation[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

@media (max-width: 575.98px) {
  .protection-weight-row {
    display: flex;
    flex-direction: column;
  }
  .protection-weight-col {
    width: 100%;
    max-width: 100%;
    flex: 1 1 100%;
  }
  .protection-weight-col .range-slider {
    display: block;
    width: 100%;
  }
  .protection-weight-col + .protection-weight-col {
    margin-top: 0.75rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/phone-case-details/phone-case-details.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACI,eAAA;EACA,6BAAA;EACA,kBAAA;EACA,kCAAA;EACA,UAAA;AAEJ;;AACA;EACI,qBAAA;AAEJ;;AACA;EACI,eAAA;EACA,mBAAA;AAEJ;;AACA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;AAEJ;;AACA;EACI,qBAAA;AAEJ;;AAEA;EACI,sBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,iBAAA;EACA,mBAAA;AACJ;;AAEA;EACI,sCAAA;AACJ;;AAEA;EACI,uBAAA;EACA,2CAAA;AACJ;;AAEA;EACI,iBAAA;AACJ;;AAEA;EACI,WAAA;AACJ;;AAEA;EACI,kBAAA;AACJ;;AAEA;EACI,WAAA;EACA,kBAAA;EACA,eAAA;EACA,2BAAA;AACJ;;AAEA;;;EAGI,cAAA;AACJ;;AAEA;EACI,yBAAA;EACA,YAAA;EACA,WAAA;EACA,sCAAA;AACJ;;AAEA;;EAEI,yBAAA,EAAA,mCAAA;EACA,WAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,WAAA;AACJ;;AACA;EACI,kBAAA;EACA,aAAA;EACA,oBAAA;AAEJ;;AAAA;EACI,YAAA;EACA,UAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;AAGJ;;AADA;EACI,aAAA;AAIJ;;AAFA;EACI,qBAAA;AAKJ;;AAHA;;EAEI,qBAAA;AAMJ;;AAJA;;;;;EAKI,qBAAA;AAOJ;;AAFA;EACI,oCAAA;EACA,YAAA;AAKJ;;AAFA;;EAEI,YAAA;EACA,mBAAA;EACA,oBAAA;AAKJ;;AAFA;EACI;IACI,aAAA;IACA,sBAAA;EAKN;EAFE;IACI,WAAA;IACA,eAAA;IACA,cAAA;EAIN;EAFM;IACI,cAAA;IACA,WAAA;EAIV;EADM;IACI,mBAAA;EAGV;AACF","sourcesContent":[".thumbnail-img {\n    cursor: pointer;\n    border: 1px solid transparent;\n    border-radius: 5px;\n    transition: border-color 0.5s ease;\n    width: 25%;\n}\n\n.thumbnail-img.active {\n    border-color: #0099e5;\n}\n\n.main-img {\n    max-width: 100%;\n    border-radius: 10px;\n}\n\n.color-swatch {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    border: 3px solid transparent;\n    cursor: pointer;\n}\n\n.color-swatch.active {\n    border-color: #0099e5;\n}\n\n\n.feature-box {\n    background-color: #fff;\n    border: 1px solid #dee2e6;\n    border-radius: 12px;\n    padding: 8px 12px;\n    min-width: 180px;\n    position: relative;\n    transition: border-color 0.3s ease;\n    cursor: pointer;\n}\n\n.feature-box:hover {\n    border-color: #0099e5;\n}\n\n.feature-box img {\n    border-radius: 4px;\n}\n\n.badge {\n    font-size: 10px;\n    margin-top: -8px;\n}\n\n.card-img-top {\n    max-height: 300px;\n    object-fit: contain;\n}\n\n.card {\n    transition: transform 0.3s ease-in-out;\n}\n\n.card:hover {\n    transform: scale(1.015);\n    border-bottom: 3px solid #0099e5 !important;\n}\n\n.tab-pane ul li {\n    padding: 0.5rem 0;\n}\n\n.tab-pane strong {\n    color: #333;\n}\n\n.tab-pane .text-muted {\n    font-size: 0.95rem;\n}\n\n.rating-input i {\n    color: #ccc;\n    font-size: 1.25rem;\n    cursor: pointer;\n    transition: color 0.2s ease;\n}\n\n.rating-input i:hover,\n.rating-input i.active,\n.rating-input i.hovered {\n    color: #0099e5;\n}\n\n.btn-custom-theme {\n    background-color: #0099e5;\n    border: none;\n    color: #fff;\n    transition: background-color 0.3s ease;\n}\n\n.btn-custom-theme:hover,\n.btn-custom-theme:focus {\n    background-color: #0078c2; /* Slightly darker shade on hover */\n    color: #fff;\n}\n\n.rate {\n    float: left;\n    height: 46px;\n    padding: 0x;\n}\n.rate:not(:checked) > input {\n    position:absolute;\n    left:-9999px;\n    pointer-events: none;\n}\n.rate:not(:checked) > label {\n    float:right;\n    width:1em;\n    overflow:hidden;\n    white-space:nowrap;\n    cursor:pointer;\n    font-size:30px;\n    color:#ccc;\n}\n.rate:not(:checked) > label:before {\n    content: '★ ';\n}\n.rate > input:checked ~ label {\n    color: var(--primary);\n}\n.rate:not(:checked) > label:hover,\n.rate:not(:checked) > label:hover ~ label {\n    color: var(--primary);\n}\n.rate > input:checked + label:hover,\n.rate > input:checked + label:hover ~ label,\n.rate > input:checked ~ label:hover,\n.rate > input:checked ~ label:hover ~ label,\n.rate > label:hover ~ input:checked ~ label {\n    color: var(--primary);\n}\n\n\n\n.isActive {\n    background-color: #e15454 !important;\n    color: white;\n}\n\n.btn-animation.btn-disabled,\n.btn-animation[disabled] {\n    opacity: 0.5;\n    cursor: not-allowed;\n    pointer-events: none;\n}\n\n@media (max-width: 575.98px) {\n    .protection-weight-row {\n        display: flex;\n        flex-direction: column;\n    }\n\n    .protection-weight-col {\n        width: 100%;\n        max-width: 100%;\n        flex: 1 1 100%;\n\n        .range-slider {\n            display: block;\n            width: 100%;\n        }\n\n        & + .protection-weight-col {\n            margin-top: 0.75rem;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
